// extracted by mini-css-extract-plugin
module.exports = {"InfoTable":"InfoTable_InfoTable__19nfY"};